var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["h-100", "d-flex", "flex-column", _vm.theme] }, [
    _c(
      "div",
      {
        staticClass: "editor-toolbar d-flex align-items-center p-1 form-inline"
      },
      [
        _c("label", { staticClass: "mr-1 mb-0 p-1" }, [
          _vm._v(_vm._s(_vm.T.fontSize))
        ]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedFontSize,
                expression: "selectedFontSize"
              }
            ],
            staticClass: "custom-select-sm",
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedFontSize = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.onFontSizeChange
              ]
            }
          },
          _vm._l(_vm.fontSizes, function(size) {
            return _c("option", { key: size, domProps: { value: size } }, [
              _vm._v(" " + _vm._s(size) + "px ")
            ])
          }),
          0
        )
      ]
    ),
    _c("div", {
      ref: "editorContainer",
      staticClass: "editor flex-grow-1 w-100 h-100"
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }